import React from 'react'
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TableContainer,
  Typography,
  Box
} from '@mui/material'

export const PLANKTON_BIOLOGY_COLUMNS = [
  { label: 'Station ID', key: 'STATIONID' },
  { label: 'Sample Key', key: 'v_c_p_s' },
  { label: 'Date', key: 'SAMPLE_DATE' },
  { label: 'Year', key: 'YEAR' },
  { label: 'CIU Taxon', key: 'CIU_TAXON' },
  { label: 'CIU Biocode', key: 'CIU_BIO_ICH' },
  { label: 'Taxon', key: 'TAXON' },
  { label: 'Catalog No.', key: 'CATALOG_NO' },
  { label: 'MEAS', key: 'MEAS' },
  { label: 'NOT_MEAS', key: 'NOT_MEAS' },
  { label: 'Raw Count', key: 'RAW_COUNT' },
  { label: 'Aliquot', key: 'ALIQUOT' },
  { label: 'Gear', key: 'GEAR_ICD' },
  { label: 'Mesh', key: 'MESH_ICD' },
  { label: 'Volume Filtered', key: 'VOL_FILT' },
  { label: 'Max Depth', key: 'DEPTH_IMAX' },
]

export const formatPlanktonBiologyRowForExport = (row) => ({ ...row })

export default function PointDataTablePlanktonBiology({ data }) {
  const rows = Array.isArray(data) ? data : []
  if (rows.length === 0) return null

  return (
    <Box sx={{ width: '100%', px: { xs: '0.5rem', sm: '1rem' } }}>
      <Box sx={{ mb: { xs: 1, sm: 2 } }}>
        <Typography variant="h6" sx={{ color: '#2E5A88', fontSize: { xs: '0.9rem', sm: '1rem' } }}>
          Plankton Biology Records
        </Typography>
      </Box>
      <TableContainer component={Paper} elevation={2} sx={{ width: '100%', overflowX: 'auto' }}>
        <Table sx={{ width: '100%', minWidth: { xs: '1100px', md: '100%' } }}>
          <TableHead>
            <TableRow>
              {PLANKTON_BIOLOGY_COLUMNS.map((col) => (
                <TableCell
                  key={col.key}
                  sx={{
                    fontWeight: 'bold',
                    backgroundColor: '#f5f5f5',
                    borderBottom: '2px solid #ccc',
                    color: '#1a2a3a',
                    fontSize: { xs: '0.75rem', sm: '0.875rem' },
                    whiteSpace: 'nowrap'
                  }}
                >
                  {col.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <TableRow key={`${row.v_c_p_s || row.STATIONID}-${row.CATALOG_NO || index}`} sx={{ '&:nth-of-type(odd)': { backgroundColor: 'grey.50' } }}>
                {PLANKTON_BIOLOGY_COLUMNS.map((col) => (
                  <TableCell
                    key={`${index}-${col.key}`}
                    sx={{
                      color: '#333333',
                      fontSize: { xs: '0.75rem', sm: '0.875rem' },
                      whiteSpace: 'nowrap'
                    }}
                  >
                    {row[col.key] ?? ''}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
